/**
 * AuthContext.js — Contexte d'authentification global
 *
 * Expose : currentUser, authPage, handleLogin, handleLogout, pending2FA
 * Consommé par tous les composants qui ont besoin de l'identité utilisateur,
 * sans prop drilling depuis App.jsx.
 *
 * Usage :
 *   import { useAuth } from '../contexts/AuthContext';
 *   const { currentUser, handleLogout } = useAuth();
 */
import React, { createContext, useContext } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children, value }) {
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth doit être utilisé dans un AuthProvider');
  return ctx;
}

export default AuthContext;
